import { render, staticRenderFns } from "./InsightTable.vue?vue&type=template&id=5ae6a062&scoped=true&"
import script from "./InsightTable.vue?vue&type=script&lang=js&"
export * from "./InsightTable.vue?vue&type=script&lang=js&"
import style0 from "./InsightTable.vue?vue&type=style&index=0&id=5ae6a062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae6a062",
  null
  
)

export default component.exports